import { request } from '../request';

const coupon = {
  /* 获取优惠券中心的列表数据 */
  getCouponsList: (data) =>
    request('/api/customer/coupon_list', 'get', data, {
      successMsg: false,
      errorMsg: false,
    }),
  /* 快捷注册弹窗登录后-优惠券列表 */
  getLoginCouponsList: (data) =>
    request('/api/customer/login_coupon', 'get', data, {
      successMsg: false,
      errorMsg: false,
    }),
  /* 领取优惠券 */
  getCoupon: (data, flag = true) =>
    request('/api/customer/get_coupon', 'post', data, {
      successMsg: flag,
      errorMsg: flag,
    }),
  /* 领取多张优惠券 */
  getCoupons: (data, flag = true) =>
    request('/api/customer/get_coupons', 'post', data, {
      successMsg: flag,
      errorMsg: flag,
    }),
  /* 领取优惠券 */
  annvgetCoupon: (data) =>
    request('/api/customer/get_coupon', 'post', data, {
      successMsg: true,
      errorMsg: false,
    }),
  /* 获取用户拥有的优惠券的列表数据 */
  getCustomerCouponsList: (data) => request('/api/customer/get_customer_coupon', 'get', data),
  // 老客获取免邮券
  getFreeShippingCoupon: () =>
    request(
      '/api/customer/freeshipping_coupon',
      'get',
      {},
      {
        successMsg: false,
        errorMsg: false,
      },
    ),

  // 获取2025周年庆优惠券
  getCouponsForAnniversary: (data) =>
    request('/api/customer/get_coupons_for_anniversary', 'get', data, {
      successMsg: true,
      errorMsg: false,
    }),
  // 获取2025周年庆升级优惠券
  getCouponsForAnniversaryUpgrade: (data) =>
    request('/api/customer/get_coupons_for_anniversary_upgrade', 'get', data, {
      successMsg: false,
      errorMsg: false,
    }),
};
export default coupon;
